<template>
  <component :is="element" class="house-notes-logo">
    <div v-html="svg" />
    <span>House Notes</span>
  </component>
</template>

<script>

export default {
  props: {
    element: {
      type: String,
      default: 'h2',
      required: false
    }
  },
  computed: {
    svg () {
      return require('./house-notes.svg')
    }
  }
}
</script>

<style lang="scss">


.house-notes-logo {
  min-width: 80px;
  @include ratio(346, 32);
  position: relative;

  div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  svg {
    display: block;
    margin: 0 auto;
    height: 100%;
    width: 100%;
    overflow: visible;

    &:not(:root) {
      overflow: visible;
    }

    @include mobile-sm {
      max-width: 90%;
    }
  }
  span {
    @include visually-hidden;
  }
}

</style>
